import React from "react";

import type { ActionItemIntegration } from "~/integrations/actionItemIntegration/index";
import { Modal } from "~/ui/legacyFellowIndex";
import { __globalModalContext } from "~/ui/modals";

function PromptActionItemAlreadyConnected({
	close,
	integration,
}: {
	integration: ActionItemIntegration;
	close: () => void;
}) {
	return (
		<Modal onClose={close}>
			<Modal.Header>
				<Modal.Title>
					{integration.logo} {integration.displayName}
				</Modal.Title>
				<Modal.HeaderActions onClose={close} />
			</Modal.Header>
			<Modal.Body textOnly>
				This Action Item is already connected to an integration. Please disconnect it first.
			</Modal.Body>
		</Modal>
	);
}

export function promptActionItemAlreadyConnected(integration: ActionItemIntegration) {
	__globalModalContext?.open(({ close }) => (
		<PromptActionItemAlreadyConnected close={close} integration={integration} />
	));
}
